import api from './api'
import { PageResponse } from '@/types/comum'
import {
  NotificacaoAdmin,
  NotificacaoAdminDetalhe,
  NotificacaoAdminResumo,
  NotificacaoHistoricoFiltro,
  NotificacaoReprocessarResultado,
} from '@/types/notificacaoAdmin'

const BASE_URL = '/api/v1/notificacoes'

function paramsDe(filtro: NotificacaoHistoricoFiltro, incluirStatus: boolean): URLSearchParams {
  const params = new URLSearchParams()
  if (incluirStatus && filtro.status) params.append('status', filtro.status)
  if (filtro.canal) params.append('canal', filtro.canal)
  if (filtro.evento) params.append('evento', filtro.evento)
  if (filtro.destinatario?.trim()) params.append('destinatario', filtro.destinatario.trim())
  if (filtro.de) params.append('de', filtro.de)
  if (filtro.ate) params.append('ate', filtro.ate)
  return params
}

/**
 * Central de notificações do back-office (A14). Visão global — OPERADOR+ lê,
 * só ADMIN reprocessa (o backend recusa com 403; a tela esconde o botão).
 */
export const notificacoesAdminService = {
  historico: async (
    filtro: NotificacaoHistoricoFiltro,
    page = 0,
    size = 20
  ): Promise<PageResponse<NotificacaoAdmin>> => {
    const params = paramsDe(filtro, true)
    params.append('page', String(page))
    params.append('size', String(size))
    params.append('sort', 'criadaEm,desc')
    return api.get<PageResponse<NotificacaoAdmin>>(`${BASE_URL}/historico?${params.toString()}`)
  },

  resumo: async (filtro: NotificacaoHistoricoFiltro = {}): Promise<NotificacaoAdminResumo> => {
    const params = paramsDe(filtro, false)
    const qs = params.toString()
    return api.get<NotificacaoAdminResumo>(`${BASE_URL}/resumo${qs ? `?${qs}` : ''}`)
  },

  detalhe: async (id: string): Promise<NotificacaoAdminDetalhe> => {
    return api.get<NotificacaoAdminDetalhe>(`${BASE_URL}/historico/${id}`)
  },

  /** Idempotente: fora de FALHA devolve `reprocessada=false` com o estado atual. */
  reprocessar: async (id: string): Promise<NotificacaoReprocessarResultado> => {
    return api.post<NotificacaoReprocessarResultado>(`${BASE_URL}/${id}/reprocessar`)
  },
}

export default notificacoesAdminService
